import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { signOut } from "firebase/auth";
import { LogOut } from "lucide-react";
import { auth, db } from "../lib/firebase";
import { Container } from "../components/ui";
import SubmissionsTable from "./SubmissionsTable";
import LegalPagesEditor from "./LegalPagesEditor";

const WAITLIST_COLUMNS = [
  { key: "name", label: "Name" },
  { key: "mobile", label: "Mobile" },
  { key: "email", label: "Email" },
  { key: "area", label: "Area" },
  { key: "vehicleType", label: "Vehicle", options: ["Car", "Bike", "Both"] },
];

const OWNER_COLUMNS = [
  { key: "name", label: "Name" },
  { key: "mobile", label: "Mobile" },
  { key: "location", label: "Location" },
  {
    key: "spaceType",
    label: "Space Type",
    options: ["Home", "Shop", "Office", "Apartment", "Restaurant", "Other"],
  },
  { key: "numberOfSpaces", label: "Spaces", type: "number" },
];

function useCollection(name) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, name), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(
      q,
      (snap) => {
        setRows(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      () => setLoading(false)
    );
    return unsub;
  }, [name]);

  return { rows, loading };
}

export default function AdminDashboard() {
  const waitlist = useCollection("waitlist");
  const owners = useCollection("ownerRegistrations");

  return (
    <div className="min-h-screen bg-[var(--color-bg-soft)] pb-20">
      <div className="border-b border-navy/8 bg-white">
        <Container className="flex items-center justify-between py-5">
          <h1 className="text-xl font-extrabold text-navy">PARKORA Admin</h1>
          <button
            type="button"
            onClick={() => signOut(auth)}
            className="focus-ring inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-bold text-navy/60 hover:bg-navy/5"
          >
            <LogOut size={16} /> Sign Out
          </button>
        </Container>
      </div>

      <Container className="mt-8 flex flex-col gap-8">
        {waitlist.loading || owners.loading ? (
          <p className="text-navy/50">Loading submissions…</p>
        ) : (
          <>
            <SubmissionsTable
              title="Waitlist Signups"
              collectionName="waitlist"
              columns={WAITLIST_COLUMNS}
              rows={waitlist.rows}
            />
            <SubmissionsTable
              title="Owner Registrations"
              collectionName="ownerRegistrations"
              columns={OWNER_COLUMNS}
              rows={owners.rows}
            />
            <LegalPagesEditor />
          </>
        )}
      </Container>
    </div>
  );
}
